module.exports = __webpack_public_path__ + "img/customBanner.60bd60e7.png";